import { useState } from 'react';
import { Form, Row, Col, Button } from 'react-bootstrap';
import { addLanguage } from '../store/languageSlice';
import { useDispatch } from 'react-redux';

const Language = () => {
  const [name, setName] = useState('');
  const [level, setLevel] = useState('Beginner');
  const dispatch = useDispatch();

  const handleAdd = () => {
    if (!name) return;
    dispatch(addLanguage({ id: name, name, level: level as any }));
    setName('');
    setLevel('Beginner');
  };

  return (
    <Row className="mb-3">
      <Col>
        <Form.Select className='mb-2' value={level} onChange={(e) => setLevel(e.target.value)}>
          <option>Beginner</option>
          <option>Elementary</option>
          <option>Intermediate</option>
          <option>Advanced</option>
          <option>Native</option>
        </Form.Select>
        <Form.Control placeholder="Language" value={name} onChange={(e) => setName(e.target.value)} />
        <Button className='mt-2' onClick={handleAdd}>Add</Button>
      </Col>
    </Row>
  );
};

export default Language;
